import { useLighterPositions } from "../../hooks/api/lighter/useLighterPositions";

type Snapshot = ReturnType<typeof useLighterPositions>;

export function LighterCoverage({ robinhood, mainnet }: { robinhood: Snapshot; mainnet: Snapshot }) {
  const complete = robinhood.available && mainnet.available;
  return (
    <div role={complete ? "status" : "alert"} style={{ padding: 12, marginBottom: 12, border: `1px solid ${complete ? "#555" : "#e9a23b"}`, borderRadius: 6 }}>
      {[robinhood, mainnet].map((snapshot) => (
        <div key={snapshot.deployment}>
          Lighter {snapshot.deployment === "mainnet" ? "Mainnet" : "Robinhood"}: {snapshot.available ? "Current" : "Unavailable"}
          {snapshot.observedAt && ` · last successful read ${new Date(snapshot.observedAt).toISOString()}`}
        </div>
      ))}
      {!complete && <strong>Net exposure unavailable until both Lighter accounts have current positions.</strong>}
    </div>
  );
}
